import Vue from 'vue';
import Vuex, { Store } from 'vuex';
Vue.use(Vuex);

export const ENTITIES = Object.freeze({
    sun: 'The Sun',
    mercury: 'Mercury',
    venus: 'Venus',
    earth: 'Earth',
    mars: 'Mars',
    jupiter: 'Jupiter',
    saturn: 'Saturn',
    uranus: 'Uranus',
    netpune: 'Neptune',
});

const sceneSettingsStore = {
    state: {
        showLabels: true,
        showOrbitalLines: true,
        showStars: false,
        paused: false,
        focusOn: 'sun',
    },
    mutations: {
        setSetting(state, { setting, value }) {
            state[setting] = value;
        },
    },
    actions: {
        setSetting({ commit }, { setting, value }) {
            commit('setSetting', { setting, value });
        },
    },
};

// END SCENE SETTINGS MODULE

const store = new Store({
    modules: {
        sceneSettings: sceneSettingsStore,
    },
});

export default store;
